import { Link } from "react-router-dom";
import { hotArticles } from "@/utils/news";

export default function NotFound() {
  const recommend = hotArticles(3);

  return (
    <div className="bg-background-50">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center px-4 py-20 text-center md:px-6">
        <p className="font-heading text-6xl font-black text-primary-500">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          这一页好像没有瓜
        </h1>
        <p className="mt-2 max-w-md text-sm text-foreground-600">
          你访问的页面不存在或已被移动。别急，先看看今天大家都在讨论的热门内容吧。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i> 返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600"
          >
            <i className="ri-search-line"></i> 去搜索
          </Link>
        </div>

        <div className="mt-14 w-full max-w-3xl text-left">
          <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-fire-line text-primary-500"></i> 热门推荐
          </h2>
          <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {recommend.map((item) => (
              <Link
                key={item.id}
                to={`/detail/${item.id}`}
                className="group flex cursor-pointer items-center justify-between gap-4 p-4"
              >
                <span className="line-clamp-1 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <i className="ri-arrow-right-s-line shrink-0 text-foreground-300"></i>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}